<template>
    <base-dblclick-input
      modelType="contact"
      :model-id="contact.id"
      field-name="personal_email"
      :field-value="contact.personal_email"
      inputType="email"
      @refetch="fetchNewContacts"
    >
        <span class="pr-1"><img id="email" src="@/assets/images/icons8-email-30.png" alt="email" class="w-[16px] inline"/></span>
    </base-dblclick-input>
</template>

<script>
    export default {
        name: "contact-personal-email-cell"
    }
</script>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    contact: Object
})

const emit = defineEmits(['refetch-contacts'])

function fetchNewContacts () {
    emit('refetch-contacts')
}
</script>